import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  display: flex;
  gap: 32px;

  & > figure {
    aspect-ratio: 1;
    max-width: 40px;
    width: fit-content;

    & > img {
      width: 100%;
    }
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > h3 {
    color: #17161E;
    font-size: 1.125rem;
  }

  & > p {
    color: #737185;
    font-size: 0.875rem;
  }
`
